import { useState } from 'react';
import './Report.css';

import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import API_URL from '../../config/api';
import { toast, ToastContainer } from 'react-toastify';
import { CircularProgress } from '@mui/material';

const andamentoProdutos = {
	'Relatório Geral': 'ctrl_geral',
	'Recobrimento Aerofotogramétrico': 'ctrl_aerofotogrametrico',
	'Apoio de Campo - Classe II - PCL': 'ctrl_apoio_de_campo_2_pcl',
	'Apoio de Campo - Classe II - HV e PCA': 'ctrl_apoio_de_campo_2_hv_pca',
	Fotoíndice: 'ctrl_fotoindice',
	'Perfilamento a LASER Aerotransportado': 'ctrl_laser',
	'Classificação da Nuvem de Pontos': 'ctrl_class_nuvem_de_pontos',
	'Modelo Digital de Superficie - MDS': 'ctrl_mds',
	'Modelo Digital de Terreno - MDT': 'ctrl_mdt',
	'Imagem Hipsométrica': 'ctrl_img_hipsometrica',
	'Imagem de Intensidade': 'ctrl_img_intensidade',
	Aerotriangulação: 'ctrl_aerotriangulacao',
	'Ortofotomosaico RGB/NIR': 'ctrl_ortofotomosaico',
	'Curvas de Nível': 'ctrl_curva_de_nivel',
	'Base Hidrográfica': 'ctrl_base_hidrografica',
	'Base Hidrográfica Ottocodificada': 'ctrl_base_hidrografica_ottocodificada',
	'Restituição Planimétrica': 'ctrl_restituicao_planimetrica',
	Reambulação: 'ctrl_reambulacao',
	'Edição Gráfica': 'ctrl_edicao',
};

const Report = () => {
	const [selectedServico, setSelectedServico] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const handleGenerate = async () => {
		if (!selectedServico) {
			return toast.warn('Selecione um serviço para gerar o relatório.');
		}

		setIsLoading(true);
		try {
			const response = await fetch(
				`${API_URL}/api/Report/download-reports?table=${selectedServico}`
			);
			if (!response.ok) {
				throw new Error(`Erro ao gerar o arquivo (${response.status})`);
			}

			const contentDisposition =
				response.headers.get('content-disposition') || '';
			const contentType = response.headers.get('content-type') || '';

			let filename = null;
			const filenameStarMatch = contentDisposition.match(
				/filename\*\s*=\s*UTF-8''([^;]+)/i
			);
			if (filenameStarMatch && filenameStarMatch[1]) {
				try {
					filename = decodeURIComponent(filenameStarMatch[1]);
				} catch {
					filename = filenameStarMatch[1];
				}
			}
			if (!filename) {
				if (
					selectedServico === 'ctrl_geral' ||
					contentType.includes('pdf')
				) {
					filename = 'relatorio_final.pdf';
				} else if (contentType.includes('zip')) {
					filename = `${selectedServico}_relatorio.zip`;
				} else {
					filename = `${selectedServico}_download`;
				}
			}

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);

			toast.success('Arquivo gerado com sucesso!');
		} catch (error) {
			toast.error(`Erro: ${error.message}`);
		} finally {
			setIsLoading(false);
		}
	};

	const entries = Object.entries(andamentoProdutos);
	const [firstLabel, firstValue] = entries[0];
	const rest = entries.slice(1);

	return (
		<>
			{isLoading && (
				<div className="loading-overlay">
					<div style={{ textAlign: 'center' }}>
						<CircularProgress size={60} thickness={5} />
						<p
							style={{
								marginTop: '10px',
								fontSize: '16px',
								color: '#233777',
							}}
						>
							Gerando relatório...
						</p>
					</div>
				</div>
			)}

			<div className="page-layout">
				<Navbar />
				<ToastContainer position="top-right" autoClose={3000} />

				<div className="page-content">
					<div className="report-container">
						<h2>Gerar Relatório</h2>
						<p>
							Escolha o serviço abaixo e clique para gerar o Zip
							contendo os PDFs.
						</p>

						<div className="linha-relatorio-geral">
							<label className="checkbox-label checkbox-solo">
								<input
									type="checkbox"
									checked={selectedServico === firstValue}
									onChange={() =>
										setSelectedServico(firstValue)
									}
								/>
								{firstLabel}
							</label>
						</div>

						<hr className="servicos-separador" />

						<div className="grid-checkboxes">
							{rest.map(([label, value]) => (
								<label key={label} className="checkbox-label">
									<input
										type="checkbox"
										checked={selectedServico === value}
										onChange={() =>
											setSelectedServico(value)
										}
									/>
									{label}
								</label>
							))}
						</div>

						<div className="buttom-container">
							<button
								className="button-gerar"
								onClick={handleGenerate}
								disabled={isLoading}
							>
								{isLoading ? 'Gerando...' : 'Gerar PDF'}
							</button>
						</div>
					</div>
				</div>

				<Footer />
			</div>
		</>
	);
};

export default Report;
